import { call, put, takeEvery } from 'redux-saga/effects'
import * as priceCategorieActions from '../ducks/priceCategorieDucks'
import * as priceCategorieApi from '../../api/priceCategorieApi'

interface FetchPriceCategorieListSaga {
  type: string
  payload: string
}

interface FetchPriceCategorieDetailSaga {
  type: string
  payload: string
}

function* fetchListPriceCategorie({ payload: queryString }: FetchPriceCategorieListSaga) {
  try {
    const res: ReturnType<typeof priceCategorieApi.getListPriceCategorie> = yield call(priceCategorieApi.getListPriceCategorie, queryString)
    yield put(priceCategorieActions.getListPriceCategorieSuccess(res))
  } catch (error) {
    yield put(priceCategorieActions.getListPriceCategorieFail(error))
  }
}

function* fetchDetailPriceCategorie({ payload: id }: FetchPriceCategorieDetailSaga) {
  try {
    const res: ReturnType<typeof priceCategorieApi.getDetailPriceCategorie> = yield call(priceCategorieApi.getDetailPriceCategorie, id)
    yield put(priceCategorieActions.getDetailPriceCategorieSuccess(res))
  } catch (error) {
    yield put(priceCategorieActions.getDetailPriceCategorieFail(error))
  }
}


export default function* watchPriceCategorie() {
  yield takeEvery(priceCategorieActions.getListPriceCategorie.toString(), fetchListPriceCategorie)
  yield takeEvery(priceCategorieActions.getDetailPriceCategorie.toString(), fetchDetailPriceCategorie)
}
